/**
 * Dummy form submit — no external API calls.
 * @param {FormData} formData
 * @returns {Promise<Response>}
 */
export async function submitWeb3Form(formData) {
  await new Promise((r) => setTimeout(r, 600));
  void formData;
  return {
    ok: true,
    async json() {
      return { success: true, message: 'OK' };
    },
  };
}

/** @param {{ json: () => Promise<unknown> }} response */
export async function parseWeb3Response(response) {
  return response.json();
}
